import { useEffect, useState } from 'react';

export type UseImageLoadedProps = {
  src?: string;
  srcSet?: string;
};

type State = 'pending' | 'loaded' | 'error';
type UseImageReturnType = { loaded: boolean; state: State };

function useImageLoaded({
  src,
  srcSet,
}: UseImageLoadedProps): UseImageReturnType {
  const [loaded, setLoaded] = useState(false);
  const [state, setState] = useState<State>(`pending`);

  useEffect(() => {
    if (!src && !srcSet) {
      return undefined;
    }

    setLoaded(false);

    let active = true;
    const image = new Image();
    image.onload = () => {
      if (!active) {
        return;
      }
      setLoaded(true);
      setState(`loaded`);
    };
    image.onerror = () => {
      if (!active) {
        return;
      }
      setLoaded(true);
      setState(`error`);
    };
    if (src) {
      image.src = src;
    }
    if (srcSet) {
      image.srcset = srcSet;
    }

    return () => {
      active = false;
    };
  }, [src, srcSet]);

  return { loaded, state };
}

export default useImageLoaded;
